module.exports = __webpack_public_path__ + "static/media/logo-sib.5f109663.svg";